import { countriesOptions } from './options';

/**
 * Maps a country code to its display label
 * @param code - The country code (e.g., 'US', 'GB')
 * @returns The country label or the original code if not found
 */
export const getCountryLabel = (code: string): string => {
  const country = countriesOptions.find((option) => option.value === code);
  return country?.label || code;
};

/**
 * Maps an array of country codes to their display labels
 * @param codes - Array of country codes
 * @returns Array of country labels
 */
export const getCountryLabels = (codes: string[]): string[] => {
  return codes.map((code) => getCountryLabel(code));
};
